<template>
  <van-popup v-model:show="innerShow" position="bottom" round closeable :style="{ height: '95%' }">
    <div class="repeat-fault-view flex flex-col h-full">
      <PopupTitle class="bg-white" title="重复报单提示" />
      <div class="repeat-fault-tip bg-white flex p-15">
        <van-icon name="info-o" color="#FC5820" size="16" style="margin-right:6px" />
        <div class="text-16">
          提示：检测到1分钟内有同样故障类型、位置的报单，您的报单可能与此工单重复，是否继续报单？
        </div>
      </div>
      <div class="flex-1 overflow-hidden overflow-y-scroll">
        <div class="mt-10 bg-white p-15">
          <div class="text-16 text-default font-600">
            可能重复的工单：
          </div>
          <div class="repeat-fault-content mt-15 p-15">
            <div class="repeat-fault-item flex">
              <div class="label">工单编号：</div>
              <div class="text-default">{{ data.orderid }}</div>
            </div>
            <div class="repeat-fault-item flex">
              <div class="label">工单状态：</div>
              <div class="text-default">{{ data.repairstate_name }}</div>
            </div>
            <div class="repeat-fault-item flex">
              <div class="label">故障类型：</div>
              <div class="text-default">{{ data.faulttype_name }}</div>
            </div>
            <div class="repeat-fault-item flex">
              <div class="label">报单位置：</div>
              <div class="text-default">{{ data.place_name }}</div>
            </div>
            <div class="repeat-fault-item flex">
              <div class="label">报单内容：</div>
              <div class="text-default">{{ data.cause }}</div>
            </div>
            <div v-if="data.fault_pic?.length > 0" class="repeat-fault-item flex">
              <div class="label">图片：</div>
              <div class="grid grid-cols-3 gap-8">
                <template v-for="file in data.fault_pic" :key="file.id">
                  <van-image
                    v-if="['jpg', 'png', 'jpeg', 'gif', 'bmp'].includes(file.photo_type)"
                    fit="contain"
                    width="100%"
                    height="100%"
                    :src="file.photo_file"
                    @click="handlePreview(file.photo_file)"
                  />
                  <video v-else class="col-span-3 w-full" controls>
                    <source :src="file.photo_file" />
                  </video>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterButton :show-cancel="true" ok-text="继续报单" @cancel="innerShow = false" @submit="onConfirm" />
    </div>
  </van-popup>
</template>

<script setup>
import { useVModel } from "@vueuse/core";
import PopupTitle from "@/components/PopupPicker/PopupTitle.vue";
import { ImagePreview } from "vant";
import { FooterButton } from "@/components/FormView/index";

const props = defineProps({
  show: { type: Boolean, default: false },
  data: { type: Object, default: () => {} }
});

const emit = defineEmits(["update:show", "confirm"]);

const innerShow = useVModel(props, "show", emit);

const handlePreview = url => {
  ImagePreview([url]);
};

const onConfirm = () => {
  innerShow.value = false;
  emit("confirm");
};
</script>

<style scoped lang="less">
.repeat-fault-item {
  margin-bottom: 10px;
  font-size: 16px;
  align-items: center;
}
.repeat-fault-item .label {
  width: 80px;
  flex-shrink: 0;
  color: #959fac;
}

.repeat-fault-view {
  background-color: #f0f2f5;
  .repeat-fault-tip {
    margin-top: 10px;
    padding-left: 10px;
    color: #fc5820;
  }
  .repeat-fault-content {
    border: 1px dashed #e1e3e5;
  }
}
</style>
